export default "__VITE_ASSET__abe0b28e__"